/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { connect } from "react-redux";
import { notification } from "antd";
import { ReactElement, useEffect, useState } from "react";
import { NotificationMode, NotificationTypes } from "src/constants/theme.constant";
import { CheckFillIcon, CheckIcon, CloseIcon } from "src/components/icons.component";

interface NotificationHocProps {
  storeNotification: any,
  children: ReactElement,
};

const NotificationHoc = ({
  storeNotification,
  children
} : NotificationHocProps) => {
  const [closeable, setCloseable] = useState(true);
  const [duration, setDuration] = useState(5);

  useEffect(() => {
    setNotificationConfig();
  }, [storeNotification]);

  const setNotificationConfig = () => {
    setCloseable(storeNotification?.data?.closable || true);
    setDuration(storeNotification?.data?.duration !== null || storeNotification?.data?.duration !== undefined ? storeNotification?.data?.duration : 5);

    if (storeNotification?.data?.mode) {
      if (storeNotification?.data?.mode === NotificationMode.Toast) {
        setToastNotification();
      }
      //Other Notification Mode
    }
    if (storeNotification?.data?.error) {
      notification.destroy();
      //Other Notification Mode
    }
  }

  const setToastNotification = () => {
    let isCloseable = storeNotification?.data?.closeable !== null && storeNotification?.data?.closeable !== undefined ? storeNotification?.data?.closeable : true;
    let duration = storeNotification?.data?.duration !== null && storeNotification?.data?.duration !== undefined ? storeNotification?.data?.duration : 5;
    let customConfig = {
      message: storeNotification?.data?.message,
      description: storeNotification?.data?.description,
    };
    notification.config({
      placement: 'topRight',
      closable: isCloseable,
      closeIcon: <CloseIcon />,
      maxCount: 1,
      duration: duration
    });

    switch (storeNotification?.data?.type) {
      case NotificationTypes.Error:
        notification.error(customConfig);
        break;
      case NotificationTypes.Success:
        notification.success({
          ...customConfig,
          icon: <CheckFillIcon />
        });
        break;
      case NotificationTypes.Warning:
        notification.warning(customConfig);
        break;
      case NotificationTypes.Info:
        notification.info(customConfig);
        break;
      default:
        break;
    }
  };

  return (
    <>
      {children}
    </>
  );

};

const mapStateToProps = (state:any) => ({
  storeNotification: state.notification,
});

export default connect(mapStateToProps)(NotificationHoc);
